import type {FilterProvider} from '@github-ui/filter'

import {tokenizeQuery} from './tokenize-query'
import type {QuerySegment} from './types'

export function validateQueryKeys(query: string, providers?: FilterProvider[]): QuerySegment[] {
  if (!providers) return []

  const keysSet = new Set<string>()
  for (const provider of providers) {
    keysSet.add(provider.key)
    for (const alias of provider.aliases || []) {
      keysSet.add(alias)
    }
  }

  const isInvalid = (segment: QuerySegment) => segment.type === 'text' || !keysSet.has(segment.key)

  return tokenizeQuery(query).filter(isInvalid)
}
